var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.965 14.935v19.963H5.627V6.563h21.895V2.7H5.047c-1.723 0-2.638 1.194-2.638 2.917v29.928c0 1.723 1.683 2.575 2.936 2.575h29.623c1.631 0 2.215-.856 2.215-2.575V14.935z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.67 11.714l-4.51-4.508-17.002 17.097 4.409 4.408zM9.554 32.322l7.083-2.575-4.507-4.507zM37.955 6.123L35.75 3.918a1.556 1.556 0 00-2.204 0l-2.205 2.205 4.409 4.408 2.204-2.204a1.563 1.563 0 000-2.204z"
  })));
}

export default SvgForm;